import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { MainService } from './main.service';
import { City } from './city';
import { Tag } from './tag';

@Component({
    selector: 'main',
    template: require('./main.component.html'),
    providers: [MainService]
})

export class MainComponent implements OnInit {

    router: Router;
    selectedLanguage: string;

    userName: string;
    userRole: string;
    userIsGuest: boolean;
    userIsSuperUser: boolean;
    userIsAdmin: boolean;

    classLoginModal: any;
    loginEmail: string;
    loginPassword: string;
    loginCode: number;

    classForgetPasswordModal: any;
    forgetPasswordEmail: string;
    forgetPasswordEmailEmpty: boolean;
    forgetPasswordEmailIncorrect: boolean;

    classEmailSendedModal: any;
    emailSended: boolean;

    categoryTypeFilter: string;
    sellerTypeFilter: string;
    citiesFilter: City[];
    tagsFilter: Tag[];

    citiesIds: Number[];
    tagsIds: Number[];
    elementsThatContainsSearchValueById: Element[];
    elementsThatContainsSearchValueByName: Element[];
    public isCollapsed: boolean = false;
    public toggledFilters: boolean = false;
    nMessages: number;
    searchFilter: string;

    constructor(_parentRouter: Router, private _mainService: MainService, private route: ActivatedRoute) {
        this.searchFilter = "";

        this.router = _parentRouter;
        this.selectedLanguage = "";

        this.userName = "";
        this.userRole = "guest";
        //this.setUserRole(this.userRole);

        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
        this.emailSended = false;
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;
        this.loginEmail = "";
        this.forgetPasswordEmail = "";
        this.loginPassword = "";
        this.loginCode = 0;

        this.categoryTypeFilter = null;
        this.sellerTypeFilter = null;
        this.citiesFilter = [];
        this.tagsFilter = [];

        this.citiesIds = [];
        this.tagsIds = [];
        this.elementsThatContainsSearchValueById = [];
        this.elementsThatContainsSearchValueByName = [];
        this.nMessages = 0;
    }

    ngOnInit() {

        this.selectedLanguage = this._mainService.getLanguage();

        this.applyFilters();

        this._mainService.getUserStatus().then(status => {
            this.userRole = status.role;
            localStorage.setItem("userRole", this.userRole);
            this.setUserRole(this.userRole);
            if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
                this.userName = this._mainService.getUserName();
                this._mainService.getUnreadMessages().then(res => {
                    if (res != null) {
                        this.nMessages = res.length;
                    }
                });
            }

        });
        this.toggledFilters = false;
    }

    applyFilters() {

        console.log(this.route.snapshot.firstChild.params);
        var category: string = this.route.snapshot.firstChild.params['categoryType'];
        if (category != null && category != undefined && category != "null" && category != "" && category != "undefined") {
            this.categoryTypeFilter = category;
        }

        var seller: string = this.route.snapshot.firstChild.params['sellerType'];
        if (seller != null && seller != undefined && seller != "null" && seller != "" && seller != "undefined") {
            this.sellerTypeFilter = seller;
        }

        var citiesParam: string = this.route.snapshot.firstChild.params['citiesFilter'];
        if (citiesParam != null && citiesParam != undefined && citiesParam != "null" && citiesParam != "" && citiesParam != "undefined") {
            var cities: string[] = citiesParam.split("+");
            for (var i = 0; i < cities.length; i++) {
                this.citiesIds.push(Number(cities[i]));
            }
        }

        var tagsParam: string = this.route.snapshot.firstChild.params['tagsFilter'];
        if (tagsParam != null && tagsParam != undefined && tagsParam != "null" && tagsParam != "" && tagsParam != "undefined") {
            var tags: string[] = tagsParam.split("+");
            for (var i = 0; i < tags.length; i++) {
                this.tagsIds.push(Number(tags[i]));
            }
        }

    }

    getLanguageColor(lang: string) {
        if (this.selectedLanguage.toUpperCase() == lang) {
            return "#6fb3cb";
        } else {
            return "#ffffff";
        }
    }

    setUserRole(userRole: string) {

        if (userRole == "guest") {
            this.userIsGuest = true;
            this.userIsSuperUser = false;
            this.userIsAdmin = false;
        } else if (userRole == "user") {
            this.userIsGuest = false;
            this.userIsSuperUser = true;
            this.userIsAdmin = false;
        } else if (userRole == "superuser") {
            this.userIsGuest = false;
            this.userIsSuperUser = true;
            this.userIsAdmin = false;
        } else if (userRole == "admin") {
            this.userIsGuest = false;
            this.userIsSuperUser = false;
            this.userIsAdmin = true;
        }

    }

    languageClicked(lang: string) {
        if (this.selectedLanguage.toUpperCase() != lang.toUpperCase()) {
            this.selectedLanguage = lang;
            localStorage.setItem("language", lang);
            location.reload();
            //this._mainService.changeLanguage(lang.toLowerCase());
            //TODO: Redirigir cap al Hostname del llenguatge seleccionat(www.mercatambulant.cat || www.mercadilloambulante.com)
            //S'ha de tenir en compte que el Token no es compartit entre els 2 Hostname(quedarà fora de sessió al fer la redirecció, entre altres coses...)
        }
    }

    accesButtonClicked() {

        if (this.userRole == "guest") {

            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;

        } else if (this.userRole == "superuser" || this.userRole == "admin" || this.userRole == "user") {

            localStorage.removeItem('token');
            localStorage.removeItem('userName');
            localStorage.removeItem('idUser');
            localStorage.removeItem('lang');
            this.router.navigate(['/main', 'dashboard']);
            location.reload();

        }

    }

    toFavoritesClicked() {
        if (this.userRole == "guest") {
            this.accesButtonClicked();
        } else {
            this.router.navigate(['/main', 'favorites']);
        }
    }

    toMessagesClicked() {
        if (this.userRole == "guest") {
            this.accesButtonClicked();
        } else {
            this.router.navigate(['/main', 'messages']);
        }
    }

    toProfileClicked() {
        if (this.userRole == "superuser" || this.userRole == "admin") {
            this._mainService.getUserStatus().then(res => {
                localStorage.setItem("userActive", res.active);
                this.router.navigate(['/superuser', 'dashboard']);
            });
        } else {
            this.router.navigate(['/main', 'profile']);
        }
    }

    categoryTypeClicked(categoryType: string) {
        if (this.categoryTypeFilter != categoryType) {
            this.categoryTypeFilter = categoryType;
        } else {
            this.categoryTypeFilter = null;
        }

        var search_filter: string;
        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
            search_filter = null;
        } else {
            search_filter = this.searchFilter;
        }
        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
    }

    sellerTypeClicked(sellerType: string) {
        if (this.sellerTypeFilter != sellerType) {
            this.sellerTypeFilter = sellerType;
        } else {
            this.sellerTypeFilter = null;
        }

        var search_filter: string;
        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
            search_filter = null;
        } else {
            search_filter = this.searchFilter;
        }

        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
    }

    getSellerType(sellerType: string) {
        return (sellerType == this.sellerTypeFilter);
    }

    getSellerTypeColor(sellerType: string) {
        if (sellerType == this.sellerTypeFilter) {
            return "#6fb3cb";
        } else {
            return "black";
        }
    }

    getSellerSelection(sellerType: string) {
        return sellerType == this.sellerTypeFilter;
    }

    getCategoryType(categoryType: string) {
        return categoryType == this.categoryTypeFilter;
    }

    getCategoryTypeColor(categoryType: string) {
        if (categoryType == this.categoryTypeFilter) {
            return "#6fb3cb";
        } else {
            return "black";
        }
    }

    getCategorySelection(categoryType: string) {
        return categoryType == this.categoryTypeFilter;
    }

    selectedCitiesReceived(event: any) {
        console.log("WE RECEIVED!");
        this.citiesFilter = event.value;

        var search_filter: string;
        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
            search_filter = null;
        } else {
            search_filter = this.searchFilter;
        }

        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
    }

    selectedTagsReceived(event: any) {
        this.tagsFilter = event.value;

        var search_filter: string;
        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
            search_filter = null;
        } else {
            search_filter = this.searchFilter;
        }

        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
    }

    closeLoginModal() {
        this.loginCode = 0;
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
    }

    loginClicked() {

        this._mainService.login(this.loginEmail, this.loginPassword).subscribe(result => {
            this.loginCode = result.code;
            if (result !== null && result.token !== undefined) {
                localStorage.setItem('userName', result.user.name);
                localStorage.setItem('idUser', result.user.id.toString());
                this._mainService.getUserLanguage().then(res => {
                    if(res == 1) {
                        localStorage.setItem("language", "cat");
                    } else if(res == 2) {
                        localStorage.setItem("language", "esp");
                    }
                    location.reload();
                });                                
            }
        });

    }

    registerClicked() {
        this.router.navigate(['/register']);
    }

    arrayToStringByDelimeter(array: any[], delimeter: string) {
        var res = "";
        for (var i = 0; i < array.length; i++) {
            res += array[i].id;
            if (i < array.length - 1) {
                res += delimeter;
            }
        }
        if (res != "") {
            return res;
        } else {
            return null;
        }
    }

    public collapse(): void {
        this.isCollapsed = true;
    }

    noCollapse() {
        this.isCollapsed = false;
    }

    forgetPassword() {
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
        this.classForgetPasswordModal.show = true;
        this.classForgetPasswordModal.hide = false;
    }

    getPasswordByEmail() {
        if (this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
            this.forgetPasswordEmailEmpty = false;
            this._mainService.verifyEmail(this.forgetPasswordEmail).then(res => {
                if (res) {
                    this.forgetPasswordEmailIncorrect = false;
                    this._mainService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {
                        if (res == 1) {
                            this.classForgetPasswordModal.show = false;
                            this.classForgetPasswordModal.hide = true;
                            this.forgetPasswordEmailEmpty = false;
                            this.forgetPasswordEmailIncorrect = false;

                            this.classEmailSendedModal.show = true;
                            this.classEmailSendedModal.hide = false;
                        }
                    })
                } else {
                    this.forgetPasswordEmailIncorrect = true;
                }
            });
        } else {
            this.forgetPasswordEmailEmpty = true;
        }
    }

    resendEmailRecoverPassword() {
        this._mainService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {
            if (res == 1) {
                this.emailSended = true;
            }
        });
    }

    closeForgetPasswordModal() {
        this.classForgetPasswordModal.show = false;
        this.classForgetPasswordModal.hide = true;
        this.forgetPasswordEmail = "";
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;
    }

    closeEmailSendedModal() {
        this.classEmailSendedModal.show = false;
        this.classEmailSendedModal.hide = true;
        this.forgetPasswordEmail = "";
        this.emailSended = false;
    }

    searchFilterChanged(event: any) {
        if (this.searchFilter.length > 0) {
            if (event.key == "Enter") {
                this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: this.searchFilter }]);
                this.elementsThatContainsSearchValueById = [];
                this.elementsThatContainsSearchValueByName = [];
            } else {
                if (this.userRole == "guest") {
                    this._mainService.getElementsBySearchFilterValue(this.searchFilter).then(res => {
                        this.elementsThatContainsSearchValueById = [];
                        this.elementsThatContainsSearchValueByName = [];
                        if (res != null) {
                            for (var i = 0; i < res.length; i++) {
                                var introduced = false;
                                if (res[i].comercial_name.toUpperCase().includes(this.searchFilter.toUpperCase()) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                                if (res[i].id.toString().includes(this.searchFilter) && !introduced) {
                                    this.elementsThatContainsSearchValueById.push(res[i]);
                                    introduced = true;
                                }
                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((this.searchFilter.toUpperCase())) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                            }
                        }
                    });
                } else {
                    this._mainService.getElementsAuthenticatedBySearchFilterValue(this.searchFilter).then(res => {
                        this.elementsThatContainsSearchValueById = [];
                        this.elementsThatContainsSearchValueByName = [];
                        if (res != null) {
                            for (var i = 0; i < res.length; i++) {
                                var introduced = false;
                                if (res[i].comercial_name.toUpperCase().includes(this.searchFilter.toUpperCase()) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                                if (res[i].id.toString().includes(this.searchFilter) && !introduced) {
                                    this.elementsThatContainsSearchValueById.push(res[i]);
                                    introduced = true;
                                }
                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((this.searchFilter.toUpperCase())) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                            }
                        }
                    });
                }
            }
        } else {
            this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: null }]);
            this.elementsThatContainsSearchValueById = [];
            this.elementsThatContainsSearchValueByName = [];
        }
    }

    searchDataClicked(element: Element) {
        this.searchFilter = "";
        this.elementsThatContainsSearchValueById = [];
        this.elementsThatContainsSearchValueByName = [];
        this.router.navigate(['/main', 'elementdetail', { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, elementId: element.id, scroll: document.body.scrollTop, scrollHeight: document.body.scrollHeight, loadedPage: 0 }]);
    }

    searchFilterFocusOut() {
        setTimeout(() => {
            this.elementsThatContainsSearchValueById = [];
            this.elementsThatContainsSearchValueByName = [];
        }, 350);
    }

    getCurrentChildRoute(): string {
        var fullUrl: string = this.router.url;
        var urlWithoutParams: string = fullUrl.split(";")[0];
        var urlSegments: string[] = urlWithoutParams.split("/");
        return urlSegments[urlSegments.length - 1];
    }

    toMainDashboard() {        
        this.router.navigate(['/main', 'dashboard']);        
        setTimeout(function() {
            location.reload();
        }, 100);                
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/main.component.ts
 **/